import { SimpleLocalizedError, type Localizable } from "@/modules/l10n/getTransText.ts";
import { msg } from "@lingui/core/macro";
import type { CardFieldsOnApproveData } from "@paypal/paypal-js";
import { randomUUID } from "@warrenio/utils/ponyfill/randomUUID";

export type ExtendedCardFieldsOnApproveData = CardFieldsOnApproveData & {
    vaultSetupToken?: string;
};

const SESSION_ID_KEY = "paypalSessionId";

export function getPaypalSessionId(): string {
    const valueInSessionStorage = sessionStorage.getItem(SESSION_ID_KEY);
    if (valueInSessionStorage) {
        return valueInSessionStorage;
    }
    const newValue = randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, newValue);
    return newValue;
}

export function clearPaypalSessionId() {
    sessionStorage.removeItem(SESSION_ID_KEY);
}

export class PayPalVaultLoadError extends SimpleLocalizedError {
    name = "PayPalVaultLoadError";

    constructor(message?: Localizable, options?: ErrorOptions) {
        super(message ?? msg`Failed to load PayPal library`, options);
    }
}
